export default {
  methods: {
    validateState(ref) {
      // eslint-disable-next-line max-len
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
  },
};
